module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.insideForm) ? _c('div', [_c('el-autocomplete', {
    attrs: {
      "popper-class": "my-autocomplete",
      "name": _vm.setName,
      "value": _vm.getValueData,
      "fetch-suggestions": _vm.fetchSuggestions,
      "placeholder": _vm.translation ? _vm.$t((_vm.translation + ".placeholder")) : _vm.name,
      "disabled": _vm.disabled
    },
    on: {
      "focus": _vm.changeData,
      "select": _vm.handleSelect
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(_vm.showHtml(item))
          }
        })]
      }
    }], null, false, 2414759015)
  }), _vm._v(" "), (_vm.quickForm) ? _c('el-button', {
    staticClass: "small",
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.onQuickFormClick
    }
  }) : _vm._e()], 1) : _c('div', [_c('el-form-item', {
    attrs: {
      "error": _vm.error,
      "label": _vm.showLable
    }
  }, [_c('el-autocomplete', {
    attrs: {
      "popper-class": "my-autocomplete",
      "name": _vm.setName,
      "value": _vm.getValueData,
      "fetch-suggestions": _vm.fetchSuggestions,
      "placeholder": _vm.translation ? _vm.$t((_vm.translation + ".placeholder")) : _vm.name,
      "disabled": _vm.disabled
    },
    on: {
      "focus": _vm.changeData,
      "select": _vm.handleSelect
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(_vm.showHtml(item))
          }
        })]
      }
    }])
  }), _vm._v(" "), (_vm.quickForm) ? _c('el-button', {
    staticClass: "small",
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.onQuickFormClick
    }
  }) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f850b78","hasScoped":false}!./src/app/components/form/autocomplete/autocomplete.html
// module id = 3004
// module chunks = 1